import { AxiosInstance } from "axios"

import { ServiceResponse } from "../../../../../core/api/apiTypes"

import {
    MenuTemplateCategory,
    MenuTemplateChannel,
    MenuTemplateDetails,
    MenuTemplateId,
    MenuTemplateListItem,
} from "./menuTemplatesTypes"

export enum MenuTemplatesQuery {
    LIST = "menu-templates-for-merchant",
    DETAILS = "menu-template-details",
}

export type MenuTemplatesResponse = Readonly<{
    menuTemplates: MenuTemplateListItem[]
}>

export async function fetchMenuTemplates(
    { merchantId }: { merchantId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MenuTemplatesResponse> {
    const { data } = await axios.get(`/merchants/${merchantId}/menu-templates`, { signal })
    return data
}

export async function fetchMenuTemplate(
    { templateId }: { templateId: MenuTemplateId },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MenuTemplateDetails> {
    const { data } = await axios.get(`/menus/templates/${templateId}`, { signal })
    return data
}

export type SaveMenuTemplatePayload = Readonly<{
    name: string
    channels: MenuTemplateChannel[]
    categories: MenuTemplateCategory[]
}>

export async function createMenuTemplate(
    { template, merchantId }: { template: SaveMenuTemplatePayload; merchantId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post("/menus/templates", { ...template, merchant: { id: merchantId } }, { signal })
    return data
}

export async function updateMenuTemplate(
    { template, templateId }: { template: SaveMenuTemplatePayload; templateId: MenuTemplateId },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(`/menus/templates/${templateId}`, { ...template }, { signal })
    return data
}

export async function deleteMenuTemplate(
    { templateId }: { templateId: MenuTemplateId },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/menus/templates/${templateId}`, { signal })
    return data
}
